var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditCompAction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3327 19H0.666016V15.6666H17.3327V19ZM9.88268 3.32497L13.0077 6.44997L5.45768 14H2.33268V10.875L9.88268 3.32497ZM13.8993 5.5583L10.7743 2.4333L12.2993 0.908301C12.6243 0.583301 13.1494 0.583301 13.4743 0.908301L15.4243 2.8583C15.7493 3.1833 15.7493 3.7083 15.4243 4.0333L13.8993 5.5583Z",
    fill: "#68AD3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditCompAction);
export default __webpack_public_path__ + "static/media/edit-comp-action.b2d534af8af5061262022540d046a901.svg";
export { ForwardRef as ReactComponent };